export class UserType {
  idTipoUsuario!: string;
  nombre!: string;
  nivel!: number;

  constructor(tipoUsuario: UserType) {
    {
      this.idTipoUsuario = tipoUsuario.idTipoUsuario || '';
      this.nombre = tipoUsuario.nombre || '';
      this.nivel = tipoUsuario.nivel;
    }
  }
}
